import { request } from "./request";

const BASE_URL = "/api/registration";

export default {
  async registerCompany(name, email, companyName, website, marketing) {
    return await request({
      method: "POST",
      url: `${BASE_URL}/company`,
      data: { name, email, company_name: companyName, website, marketing },
    });
  },

  async register(name, email, gender, password, inviteCode) {
    return await request({
      method: "POST",
      url: `${BASE_URL}`,
      data: { name, email, gender, password, invitation_code: inviteCode },
    });
  },

  async signIn(email, password) {
    return await request({
      method: "POST",
      url: `${BASE_URL}/login`,
      data: { email, password },
    });
  },

  async forgotPassword(email, after) {
    return await request({
      method: "POST",
      url: `${BASE_URL}/forgot_password`,
      data: { email, after },
    });
  },
};
